import React from "react";
import "./CollaboratorDialog.css";
import {useUserInfo} from "../../hooks/useUserInfo";
import {useTranslation} from "react-i18next";

type OnlineUserDialogProps = {
    online_user_emails: string[],
    show: boolean;
    onClose: () => void;
}

export const OnlineUserDialog = (props: OnlineUserDialogProps) => {

    const {t} = useTranslation();
    const {userEmail} = useUserInfo();

    const ref = React.useRef<HTMLDialogElement>(null);
    const online_user_emails = [userEmail, ...props.online_user_emails];

    React.useEffect(() => {
        if (ref.current === null) {
            return;
        }

        if (props.show) {
            !ref.current.open && ref.current.showModal();
        } else {
            ref.current.open && ref.current.close();
        }
    }, [props.show]);

    return (
        <dialog ref={ref} className="collaborator-dialog-dialog"
                onCancel={() => props.onClose()}
                onClick={() => props.onClose()}>
            <div className="collaborator-dialog" onClick={e => e.stopPropagation()}>
                <h2 className="collaborator-dialog-title-area">{t("オンラインユーザー")}</h2>
                <span className="collaborator-dialog-close-button" onClick={() => props.onClose()}/>

                <div className="online-user-dialog-listing-area">
                    <ul className="online-user-dialog-listing">
                        {online_user_emails.map((email, index) =>
                            <li key={`${index}`}>
                                <div>
                                    <span>{email}</span>
                                    {email === userEmail && <span className="is_you">{t("あなた")}</span>}
                                </div>
                            </li>
                        )}
                    </ul>

                </div>
            </div>
        </dialog>
    );
}
